module.exports = __webpack_public_path__ + "img/casa.77076201.png";